const config = {
  apiUrl: import.meta.env.VITE_API_URL ?? "https://prod-api.sweatch.ai",
  adminApiUrl: import.meta.env.VITE_ADMIN_API_URL ?? "https://prod-admin-api.sweatch.ai",
  partnerApiUrl: import.meta.env.VITE_PARTNER_API_URL ?? "https://ad-webview-api.sweatch.ai",
  adChannelAdminApiUrl: import.meta.env.VITE_AD_CHANNEL_ADMIN_API_URL ?? "https://ad-channel-admin-api.sweatch.ai",
  analyticsApiUrl: import.meta.env.VITE_ANALYTICS_API_URL ?? "https://prod-analytics-api.sweatch.ai",
};

export default config;
